import LandmarksAPI from '../api/landmarksid';
import {all, call, takeLatest, put} from 'redux-saga/effects'
import { delay } from 'redux-saga'

import {
    SAGA_LOAD_JOBS_SUMMARY,
    SAGA_PATCH_JOB,
    SET_JOBS_SUMMARY,
    SET_ACCOUNTS,
    SAGA_LOAD_ACCOUNTS,
    SAGA_CREATE_ACCOUNT,
    SAGA_LOAD_VALIDATION_STATISTICS,
} from './actions';

import {
    setError,
    resetErrors,
} from '../errors/actions';

import createHistory from 'history/createHashHistory'

const history = createHistory();

// Jobs Summary Sagas

function* getJobSummary() {
  const results = yield call(LandmarksAPI.getJobsSummary);

  // Error checking the server response
  if (results.error === null && results.json !== null){
      yield put({
          type: SET_JOBS_SUMMARY,
          payload: {
            jobsList: results.json.body,
          }
      });
  }else {
      yield put({type: 'ERROR_IN_FETCHING_DATA'});
  }
}

function* patchJob(action){
    const results = yield call(LandmarksAPI.patchJob, action.payload.jobId, action.payload.patchBody);
    // Error checking the server response
    if (results.error === null && results.json !== null){
        yield put({
            type: SAGA_LOAD_JOBS_SUMMARY,
            payload: null,
        });
    }else {
        yield put({type: 'ERROR_IN_FETCHING_DATA'});
    }
}

// Accounts Sagas

function* getAccounts() {
    const results = yield call(LandmarksAPI.getAccounts);
  
    // Error checking the server response
    if (results.error === null && results.json !== null){
        yield put({
            type: SET_ACCOUNTS,
            payload: {
              accounts: results.json.body,
            }
        });
    }else {
        yield put({type: 'ERROR_IN_FETCHING_DATA'});
    }
  }

function* createAccount(action) {
    const results = yield call(LandmarksAPI.createAccount, action.payload.account);

    // Error checking the server response
    if (results.error === null && results.json !== null){
        history.push('/admin/accounts');
    }else {
        yield put(setError(results.message));
        yield delay(4000);
        yield put(resetErrors());
    }
}

// Validation Statistics
function* getValidationStatistics() {
    const results = yield call(LandmarksAPI.getValidationStatistics);
    if (results.error !== null && results.message !== null) {
        yield put(setError(results.message));
        yield delay(4000);
        yield put(resetErrors());
    }
}

// Server functions

export default function* adminSaga(){
	yield all([
        takeLatest(SAGA_LOAD_JOBS_SUMMARY, getJobSummary),
        takeLatest(SAGA_PATCH_JOB, patchJob),

        takeLatest(SAGA_LOAD_ACCOUNTS, getAccounts),
        takeLatest(SAGA_CREATE_ACCOUNT, createAccount),

        takeLatest(SAGA_LOAD_VALIDATION_STATISTICS, getValidationStatistics),
	]);
}



// WEBPACK FOOTER //
// ./src/admin/sagas.js